import React from 'react';
import { Alert, Button } from '@mui/material';
import { useDashboardDrilldown } from '../../hooks/useDashboardDrilldown';

const fmt = (v) => {
  const d = new Date(`${v}T00:00:00`);
  return Number.isNaN(d.getTime()) ? v : d.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
};

/** Shown on a list opened from a dashboard card; "Clear" drops the drill-down and shows the full list. */
const DashboardDrilldownBanner = () => {
  const { active, params, label, clear } = useDashboardDrilldown();
  if (!active) return null;

  const period = params.dd_from || params.dd_to
    ? ` · ${params.dd_from ? fmt(params.dd_from) : '…'} – ${params.dd_to ? fmt(params.dd_to) : '…'}`
    : ' · this month';

  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      action={<Button color="inherit" size="small" onClick={clear}>Clear</Button>}
    >
      Showing records behind the dashboard card “{label || params.dd_metric}”{period}
    </Alert>
  );
};

export default DashboardDrilldownBanner;
